// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database"; // ✅ Import Realtime Database


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBYNe3xKLfTDl5XvwcWBFrk77cAUEZQx7Q",
  authDomain: "digihealcontactformdata.firebaseapp.com",
  databaseURL: "https://digihealcontactformdata-default-rtdb.firebaseio.com",
  projectId: "digihealcontactformdata",
  storageBucket: "digihealcontactformdata.firebasestorage.app",
  messagingSenderId: "413215533579",
  appId: "1:413215533579:web:8f23f6d3deb4388a46750e",
  measurementId: "G-GV2GD2SRNL"
};

// Initialize Firebase
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firestore & Realtime Database
export const db = getFirestore(app);     // Firestore
export const rtdb = getDatabase(app);    // Realtime Database
